import { NgModule, ErrorHandler } from '@angular/core';
import { AngularFireModule } from '@angular/fire';
import { AngularFireAuthModule } from '@angular/fire/auth';
import { AngularFireDatabaseModule } from '@angular/fire/database';
import { BrowserModule } from '@angular/platform-browser';
import { AppVersion } from '@ionic-native/app-version';
import { BackgroundMode } from '@ionic-native/background-mode';
import { Device } from '@ionic-native/device';
import { File } from '@ionic-native/file';
import { FileOpener } from '@ionic-native/file-opener';
import { Geolocation } from '@ionic-native/geolocation';
import { LocalNotifications } from '@ionic-native/local-notifications';
import { SplashScreen } from '@ionic-native/splash-screen';
import { StatusBar } from '@ionic-native/status-bar';
import { IonicApp, IonicModule, IonicErrorHandler } from 'ionic-angular';

import { MyApp } from './app.component';
import { GlobalVars } from './app.environment';
import { FIREBASE_CONFIG } from './app.firebase.config';
import { IonDigitKeyboard } from '../components/ion-digit-keyboard/ion-digit-keyboard.module';

// Pàgines
import { CheckInfoPageModule } from '../pages/check-info/check-info.module';
import { CodeInputPageModule } from './../pages/code-input/code-input.module';
import { ConfigurationAdminPageModule } from '../pages/configuration-admin/configuration-admin.module';
import { ConfigurationPageModule } from '../pages/configuration/configuration.module';
import { FraudsPageModule } from '../pages/frauds/frauds.module';
import { HistoryPageModule } from '../pages/history/history.module';
import { HomeAdminPageModule } from '../pages/home-admin/home-admin.module';
import { HomePageModule } from '../pages/home/home.module';
import { LoginPageModule } from '../pages/login/login.module';
import { MapPageModule } from '../pages/map/map.module';
import { ReportGlobalPageModule } from './../pages/report-global/report-global.module';
import { ReportSelectionPageModule } from '../pages/report-selection/report-selection.module';
import { ReportUserPageModule } from '../pages/report-user/report-user.module';
import { TimetableInfoPageModule } from '../pages/timetable-info/timetable-info.module';
import { TimetablesPageModule } from '../pages/timetables/timetables.module';
import { UserHistoryPageModule } from '../pages/user-history/user-history.module';
import { UserInfoPageModule } from '../pages/user-info/user-info.module';
import { UsersPageModule } from '../pages/users/users.module';
import { UsersStatusPageModule } from '../pages/users-status/users-status.module';
import { WorkplacesPageModule } from '../pages/workplaces/workplaces.module';

// Providers
import { AuthProvider } from '../providers/auth/auth';
import { CheckProvider } from '../providers/check/check';
import { CodeProvider } from '../providers/code/code';
import { ConfigurationProvider } from '../providers/configuration/configuration';
import { DatePipe } from '@angular/common';
import { FirebaseProvider } from '../providers/firebase/firebase';
import { FraudProvider } from '../providers/fraud/fraud';
import { NotificationProvider } from '../providers/notification/notification';
import { RepoProvider } from '../providers/repo/repo';
import { ReportProvider } from '../providers/report/report';
import { TimetableProvider } from '../providers/timetable/timetable';
import { UserProvider } from '../providers/user/user';
import { VersionProvider } from '../providers/version/version';
import { WorkplaceProvider } from '../providers/workplace/workplace';

@NgModule({
  declarations: [
    MyApp,
  ],
  imports: [
    BrowserModule,
    IonicModule.forRoot(MyApp, {
      monthNames: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
    }),

    AngularFireAuthModule,
    AngularFireDatabaseModule,
    AngularFireModule.initializeApp(FIREBASE_CONFIG),
    
    CheckInfoPageModule,
    CodeInputPageModule,
    ConfigurationAdminPageModule,
    ConfigurationPageModule,
    FraudsPageModule,
    HistoryPageModule,
    HomeAdminPageModule,
    HomePageModule,
    LoginPageModule,
    MapPageModule,
    ReportGlobalPageModule,
    ReportSelectionPageModule,
    ReportUserPageModule,
    TimetableInfoPageModule,
    TimetablesPageModule,
    UserHistoryPageModule,
    UserInfoPageModule,
    UsersPageModule,
    UsersStatusPageModule,
    WorkplacesPageModule,
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
  ],
  providers: [
    {provide: ErrorHandler, useClass: IonicErrorHandler},
    AppVersion,
    BackgroundMode,
    DatePipe,
    Device,
    File,
    FileOpener,
    Geolocation,
    GlobalVars,
    IonDigitKeyboard,
    LocalNotifications,
    SplashScreen,
    StatusBar,

    AuthProvider,
    CheckProvider,
    CodeProvider,
    ConfigurationProvider,
    FirebaseProvider,
    FraudProvider,
    NotificationProvider,
    RepoProvider,
    ReportProvider,
    TimetableProvider,
    UserProvider,
    VersionProvider,
    WorkplaceProvider,
  ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts